import type { ReactNode } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { MODULES, VEILIGHEID, VEILIGHEIDSUITDAGINGEN, t } from '../content/content'
import { useKiosk } from '../state/store'
import { FilmKnop, VEER } from './gedeeld'

/**
 * Veiligheid: "Welke veiligheidsuitdaging herken jij het meest?" → vier
 * antwoorden → de oplossing met haar film (flowchart 5 oktober). De film start
 * met de filmknop, niet vanzelf (21 oktober). De keuze staat in hetzelfde veld
 * als de hotspot van Automatisering; de scène zelf blijft op de
 * veiligheidsstand staan.
 */
export function Veiligheid({ terug }: { terug: ReactNode }) {
  const taal = useKiosk((s) => s.taal)
  const keuzeId = useKiosk((s) => s.hotspot)
  const kies = useKiosk((s) => s.kiesHotspot)
  const vergrendeld = useKiosk((s) => s.vergrendeld)

  const module = MODULES.find((m) => m.id === 'veiligheid')!
  const keuze = VEILIGHEIDSUITDAGINGEN.find((u) => u.id === keuzeId) ?? null


  return (
    <>
      <div className="kiosk-podium">
        <AnimatePresence mode="wait">
          {keuze ? (
            <motion.div
              key={keuze.id}
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 24 }}
              transition={VEER}
            >
              <div className="kiosk-tegel-nr">{module.nr}</div>
              <h2 className="kiosk-hero kiosk-hero-m">{keuze.oplossing}</h2>
              <p className="kiosk-onderkop">{t(keuze.uitdaging, taal)}</p>
              <p className="kiosk-oplossing">{t(keuze.omschrijving, taal)}</p>
              <ul className="kiosk-voordelen">
                {keuze.voordelen.map((v, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ ...VEER, delay: 0.18 + i * 0.07 }}
                  >
                    {t(v, taal)}
                  </motion.li>
                ))}
              </ul>
              <motion.div
                className="kiosk-hotspot-acties"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ ...VEER, delay: 0.42 }}
              >
                <FilmKnop video={keuze.video} />
              </motion.div>
            </motion.div>
          ) : (
            <motion.div
              key="vraag"
              initial={{ opacity: 0, y: 22 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={VEER}
            >
              <div className="kiosk-tegel-nr">{module.nr}</div>
              <h2 className="kiosk-hero kiosk-hero-m">{t(VEILIGHEID.vraag, taal)}</h2>
              <p className="kiosk-onderkop">{t(module.laag, taal)}</p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div className="kiosk-actiebalk">
        {terug}
        {VEILIGHEIDSUITDAGINGEN.map((u, i) => (
          <button
            key={u.id}
            className={`kiosk-tegel${keuzeId === u.id ? ' kiosk-aan' : ''}`}
            onClick={() => kies(keuzeId === u.id ? null : u.id)}
            disabled={vergrendeld}
          >
            <span className="kiosk-tegel-nr">{String(i + 1).padStart(2, '0')}</span>
            <span className="kiosk-tegel-naam kiosk-tegel-naam-klein">{t(u.uitdaging, taal)}</span>
            <span className="kiosk-tegel-sub">{u.oplossing}</span>
          </button>
        ))}
      </div>
    </>
  )
}
